import Vue from "vue";
import Meta from "vue-meta"
import App from "./App.vue";

// dotenv.config();

Vue.config.productionTip = false;
Vue.use(Meta);


new Vue({
  render: (h) => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
  metaInfo: () => ({
    title: 'Jeanna Chambers',
    titleTemplate: '%s | Newborn Photography',
    htmlAttrs: {
      lang: 'en',
      amp: undefined
    },
    bodyAttrs: {
      tabIndex: 0
    },
    meta: [
      { name: 'charset', content: 'utf-8' },
      { name: 'description', content: 'Professional New Born Photography in Canon City, CO and surrounding area.' },
      { name: 'viewport', content: 'width=device-width,initial-scale=1.0' },
      { name: 'author', content: 'Jeanna Chambers' },
    ],
    script: [
      { innerHTML: '{ "@context": "http://www.schema.org", "@type": "Organization" }', type: 'application/ld+json' },
      { innerHTML: '{ "body": "yes" }', body: true, type: 'application/ld+json' }
    ]
  })
}).$mount("#app");
